import { render, staticRenderFns } from "./LoteDetergenteEnzimatico.vue?vue&type=template&id=2aaafaf0&"
import script from "./LoteDetergenteEnzimatico.vue?vue&type=script&lang=js&"
export * from "./LoteDetergenteEnzimatico.vue?vue&type=script&lang=js&"
import style0 from "./LoteDetergenteEnzimatico.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports